module.exports = __webpack_public_path__ + "img/Group 6849@2x.1059a9d9.png";